import { Box, HStack, Icon, IconButton } from '@chakra-ui/react'
import {
  ArrowLeft,
  ArrowLeftToLine,
  ArrowRight,
  ArrowRightToLine,
} from 'lucide-react'
import type React from 'react'
import { Trans, useTranslation } from 'react-i18next'

interface TableFooterProps {
  page: number
  totalPages: number
  hasNextPage: boolean
  onFirstPage: () => void
  onPreviousPage: () => void
  onNextPage: () => void
  onLastPage: () => void
}

const TableFooter: React.FC<TableFooterProps> = ({
  page,
  totalPages,
  hasNextPage,
  onFirstPage,
  onPreviousPage,
  onNextPage,
  onLastPage,
}) => {
  const { t } = useTranslation(undefined, { useSuspense: false })

  return (
    <Box width="100%" display="flex" justifyContent="space-between" mt={4}>
      <HStack gap={8}>
        <HStack gap={4} data-testid="previous-pages">
          <IconButton
            onClick={onFirstPage}
            disabled={page === 1}
            aria-label={String(t('pagination.firstPage'))}
            variant="ghost"
            minWidth="24px"
            height="24px"
            border={0}
          >
            <Icon as={ArrowLeftToLine} w={6} h={6} />
          </IconButton>
          <IconButton
            onClick={onPreviousPage}
            disabled={page === 1}
            aria-label={String(t('pagination.previousPage'))}
            variant="ghost"
            minWidth="24px"
            height="24px"
            border={0}
          >
            <Icon as={ArrowLeft} w={6} h={6} />
          </IconButton>
        </HStack>

        <HStack gap={4} data-testid="next-pages">
          <IconButton
            onClick={onNextPage}
            disabled={!hasNextPage}
            aria-label={String(t('pagination.nextPage'))}
            variant="ghost"
            minWidth="24px"
            height="24px"
            border={0}
          >
            <Icon as={ArrowRight} w={6} h={6} />
          </IconButton>
          <IconButton
            onClick={onLastPage}
            disabled={page >= totalPages}
            aria-label={String(t('pagination.lastPage'))}
            variant="ghost"
            minWidth="24px"
            height="24px"
            border={0}
          >
            <Icon as={ArrowRightToLine} w={6} h={6} />
          </IconButton>
        </HStack>

        <Box data-testid="current-page">
          <Trans i18nKey="pagination.page" values={{ page, totalPages }} />
        </Box>
      </HStack>
    </Box>
  )
}

export default TableFooter
